import { connect } from 'react-redux';
import get from 'lodash/fp/get.js';
import getOr from 'lodash/fp/getOr.js';
import { getFormValues } from 'redux-form';
import ModelFormField from './ModelFormField.jsx';
import getFullyQualifiedFieldName from '#support/utility/form/getFullyQualifiedFieldName.js';
import { modelTypesByForm } from '#constants/models/modelTypes/index.js';
import { currentModelId } from '#selectors/entities/models.js';
import { selectFieldAiStatus, selectFieldProvenance } from '#selectors/entities/modelAiReview.js';
import { acceptProposedField, rejectProposedField } from '#actions/models/aiReview.js';

// TODO: considering updating the wrapper for
// the EnhancedField to cover the additional functionality added here

const mapStateToProps = (state, ownProps) => {
  const { item, field } = ownProps;

  // Return null state if field is undefined - component won't render
  if (!field) {
    return {
      visible: false,
      value: null,
      autofilled: false,
      fullyQualifiedName: null,
    };
  }

  const { name, form, autofiller } = field;
  const fullyQualifiedName = getFullyQualifiedFieldName(item, name);

  let autofilled = false;

  // If this field has autofiller get autofilled state from Redux
  if (form && autofiller && modelTypesByForm[form]) {
    const { makeFieldIsAutofilledSelector } = modelTypesByForm[form];
    const selectFieldIsAutofilled = makeFieldIsAutofilledSelector();
    autofilled = selectFieldIsAutofilled(state, { name });
  }

  // Model form visibility and value patterns
  const visible = !!get(fullyQualifiedName, getOr({}, `form[${form}].visibleFields`, state));
  const value = get(fullyQualifiedName, getFormValues(form)(state) || {});
  const readOnly =
    typeof field.readOnly === 'function'
      ? field.readOnly(state, ownProps)
      : field.readOnly || false;

  // AI-review marking (UI design §3.4) -- read from FORM STATE (aiStatus/provenance in the
  // redux-form slice), not entity state, so accept/reject transitions are local-first and instant.
  const modelId = currentModelId(state);
  const aiStatus = visible && form ? selectFieldAiStatus(form, fullyQualifiedName)(state) : 'none';
  const provenance =
    visible && form ? selectFieldProvenance(form, fullyQualifiedName)(state) : null;

  return {
    fullyQualifiedName,
    value,
    visible,
    autofilled,
    readOnly,
    aiStatus,
    provenance,
    modelId,
    form,
  };
};

const mapDispatchToProps = {
  onAcceptProposal: acceptProposedField,
  onRejectProposal: rejectProposedField,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { modelId, fullyQualifiedName, form } = stateProps;
  const { onAcceptProposal, onRejectProposal } = dispatchProps;
  return {
    ...ownProps,
    ...stateProps,
    onAcceptProposal: () => onAcceptProposal(modelId, fullyQualifiedName),
    onRejectProposal: () => onRejectProposal(modelId, fullyQualifiedName, form),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ModelFormField);
